import { PolygonSymbol3D, SimpleFillSymbol } from "@arcgis/core/symbols";
import { acearthSymbol, acearthSymbolHeight, buildingSymbology, buildingSymbologyHeight, chimneySymbology, chimneySymbologyHeight, columnsSymbology, columnsSymbologyHeight, dcearthSymbol, dcearthSymbolHeight, handrailsSymbology, handrailsSymbologyHeight, helipadSymbology, helipadSymbologyHeight, hvacSymbology, hvacSymbologyHeight, InverterSymbology, InverterSymbologyHeight, lifelineSymbology, lifelineSymbologyHeight, lightningSymbology, lightningSymbologywithHeight, metalSymbology, metalSymbologyHeight, mobileTowerSymbology, mobileTowerSymbologyHeight, modulecleaningpipeSymbology, modulecleaningpipeSymbologyHeight, mumtyStructureSymbology, mumtyStructureSymbologywithHeight, parapetSymbology, parapetSymbologyHeight, pipelineSymbology, pipelineSymbologywithHeight, ridgeSymbology, ridgeSymbologyHeight, roofSymbology, roofSymbologywithHeight, skylightSymbology, skylightSymbologyHeight, solarModuleSymbology, solarModuleSymbologyWithHeight, treeSymbology, treeSymbology_2d, walkwaySymbology, walkwaySymbologyHeight, waterTankSymbology, waterTankSymbologyHeight } from "./sketchSymbols";
import { getsimpleFillSymbol } from "../../Utils/CustomerMaps/MarkerSymbols/MarkerSymbols";


export enum roofObsType {
    Building = "buildings",
    Roof = "roof",
    Chimneys = "chimneys",
    ExistingSolarModules = "existing_solar_modules",
    ExtendedColumns = "extended_column",
    HvacEquipment = "hvac_equipment",
    MumtyStructure = "mumty_structure",
    ParapetWall = "parapet_wall",
    Pipelines = "pipelines",
    Skylights = "skylights",
    TreeLine = "tree_line",
    Turbovents = "turbovents",
    WaterTanks = "water_tanks",
    Helipad = "helipad",
    Mobile = "mobile_tower",
    Handrail = "Handrail",
    Inverter = "Inverter",
    walkway = "Walkway",
    Lifeline = "Lifeline",
    ModuleCleaningPipe = "ModuleCleaningPipe",
    LightningArrestor = "LightningArrestor",
    dc_earthing = "dc_earthing",
    ac_earthing = "ac_earthing",
    SolarModules = "SolarModules",
  }

export const getSymbols = (type: roofObsType, height: number = 0) => {
    const symbols: Record<roofObsType, { withHeight: PolygonSymbol3D, withoutHeight: PolygonSymbol3D }> = {
        buildings: { withHeight: buildingSymbologyHeight(height), withoutHeight: buildingSymbology },
        Inverter: { withHeight: InverterSymbologyHeight(height), withoutHeight: InverterSymbology },
        extended_column: { withHeight: columnsSymbologyHeight(height), withoutHeight: columnsSymbology },
        // MetalRoof: { withHeight: metalSymbologyHeight(height), withoutHeight: metalSymbology },
        // Ridge: { withHeight: ridgeSymbologyHeight(height), withoutHeight: ridgeSymbology },
        Walkway: { withHeight: walkwaySymbologyHeight(height), withoutHeight: walkwaySymbology },
        mumty_structure: { withHeight: mumtyStructureSymbologywithHeight(height), withoutHeight: mumtyStructureSymbology },
        Lifeline: { withHeight: lifelineSymbologyHeight(height), withoutHeight: lifelineSymbology },
        Handrail: { withHeight: handrailsSymbologyHeight(height), withoutHeight: handrailsSymbology },
        ModuleCleaningPipe: { withHeight: modulecleaningpipeSymbologyHeight(height), withoutHeight: modulecleaningpipeSymbology },
        water_tanks: { withHeight: waterTankSymbologyHeight(height), withoutHeight: waterTankSymbology },
        LightningArrestor: { withHeight: lightningSymbologywithHeight(height), withoutHeight: lightningSymbology },
        pipelines: { withHeight: pipelineSymbologywithHeight(height), withoutHeight: pipelineSymbology },
        hvac_equipment: { withHeight: hvacSymbologyHeight(height), withoutHeight: hvacSymbology },
        existing_solar_modules: { withHeight: solarModuleSymbologyWithHeight(height), withoutHeight: solarModuleSymbology },
        parapet_wall: { withHeight: parapetSymbologyHeight(height), withoutHeight: parapetSymbology },
        dc_earthing: { withHeight: dcearthSymbolHeight(height), withoutHeight: dcearthSymbol },
        ac_earthing: { withHeight: acearthSymbolHeight(height), withoutHeight: acearthSymbol },
        helipad: { withHeight: helipadSymbologyHeight(height), withoutHeight: helipadSymbology },
        chimneys: { withHeight: chimneySymbologyHeight(height), withoutHeight: chimneySymbology },
        skylights: { withHeight: skylightSymbologyHeight(height), withoutHeight: skylightSymbology },
        mobile_tower: { withHeight: mobileTowerSymbologyHeight(height), withoutHeight: mobileTowerSymbology },
        roof: { withHeight: roofSymbologywithHeight(height), withoutHeight: roofSymbology },
        SolarModules: { withHeight: solarModuleSymbologyWithHeight(height), withoutHeight: solarModuleSymbology },
        tree_line: { withHeight: solarModuleSymbologyWithHeight(height), withoutHeight: solarModuleSymbology },
        turbovents: { withHeight: solarModuleSymbologyWithHeight(height), withoutHeight: solarModuleSymbology },
    };

    return symbols[type];
};


export const treeSymbolObj = (height: number = 0) =>  {
    return {
        withHeight: treeSymbology_2d(height) as any, withoutHeight: treeSymbology as any
    }
}

export const getSymbolsbyNames = (name: string, height = 0) => {
    const type = name.toLowerCase();
    // Map of symbols
    const symbolMap = {
        building: { withHeight: buildingSymbologyHeight(height), withoutHeight: buildingSymbology },
        metalroof: { withHeight: metalSymbologyHeight(height), withoutHeight: metalSymbology },
        ridge: { withHeight: ridgeSymbologyHeight(height), withoutHeight: ridgeSymbology },
        walkway: { withHeight: walkwaySymbologyHeight(height), withoutHeight: walkwaySymbology },
        mumty_structure: { withHeight: mumtyStructureSymbologywithHeight(height), withoutHeight: mumtyStructureSymbology },
        lifeline: { withHeight: lifelineSymbologyHeight(height), withoutHeight: lifelineSymbology },
        handrail: { withHeight: handrailsSymbologyHeight(height), withoutHeight: handrailsSymbology },
        modulecleaningpipe: { withHeight: modulecleaningpipeSymbologyHeight(height), withoutHeight: modulecleaningpipeSymbology },
        waterstoragetank: { withHeight: waterTankSymbologyHeight(height), withoutHeight: waterTankSymbology },
        lightningarrestor: { withHeight: lightningSymbologywithHeight(height), withoutHeight: lightningSymbology },
        pipelines: { withHeight: pipelineSymbologywithHeight(height), withoutHeight: pipelineSymbology },
        hvac_equipment: { withHeight: hvacSymbologyHeight(height), withoutHeight: hvacSymbology },
        existingsolarmodules: { withHeight: solarModuleSymbologyWithHeight(height), withoutHeight: solarModuleSymbology },
        parapetwall: { withHeight: parapetSymbologyHeight(height), withoutHeight: parapetSymbology },
        dc_earthing: { withHeight: dcearthSymbolHeight(height), withoutHeight: dcearthSymbol },
        ac_earthing: { withHeight: acearthSymbolHeight(height), withoutHeight: acearthSymbol },
        columns: { withHeight: columnsSymbologyHeight(height), withoutHeight: columnsSymbology },
        Inverter: { withHeight: InverterSymbologyHeight(height), withoutHeight: InverterSymbology },
        Helipad: { withHeight: helipadSymbologyHeight(height), withoutHeight: helipadSymbology },
        Chimney: { withHeight: chimneySymbologyHeight(height), withoutHeight: chimneySymbology },
        SkyLight: { withHeight: skylightSymbologyHeight(height), withoutHeight: skylightSymbology },
        MobileTower: { withHeight: mobileTowerSymbologyHeight(height), withoutHeight: mobileTowerSymbology },
    };

    if(type.includes('skylight')){
        if(height){
            return symbolMap['SkyLight'].withHeight
        } else {
            return symbolMap['SkyLight'].withoutHeight
        }
    }
    if(type.includes('extended')){
        if(height){
            return symbolMap['columns'].withHeight
        } else {
            return symbolMap['columns'].withoutHeight
        }
    }
    if(type.includes('mobilet')){
        if(height){
            return symbolMap['MobileTower'].withHeight
        } else {
            return symbolMap['MobileTower'].withoutHeight
        }
    }

    if(type.includes('chimne')){
        if(height){
            return symbolMap['Chimney'].withHeight
        } else {
            return symbolMap['Chimney'].withoutHeight
        }
    }
    if(type.includes('invert')){
        if(height){
            return symbolMap['Inverter'].withHeight
        } else {
            return symbolMap['Inverter'].withoutHeight
        }
    }
    if(type.includes('helipad')){
        if(height){
            return symbolMap['Helipad'].withHeight
        } else {
            return symbolMap['Helipad'].withoutHeight
        }
    }
    if(type.includes('dc_earthing')){
        if(height){
            return symbolMap['dc_earthing'].withHeight
        } else {
            return symbolMap['dc_earthing'].withoutHeight
        }
    }
    if(type.includes('column')){
        if(height){
            return symbolMap['columns'].withHeight
        } else {
            return symbolMap['columns'].withoutHeight
        }
    }
    if(type.includes('ac_earthing')){
        if(height){
            return symbolMap['ac_earthing'].withHeight
        } else {
            return symbolMap['ac_earthing'].withoutHeight
        }
    }
    if(type.includes('walkway') || type.includes('walkaway')){
        if(height){
            return symbolMap['walkway'].withHeight
        } else {
            return symbolMap['walkway'].withoutHeight
        }
    }
    if(type.includes('ridge')){
        if(height){
            return symbolMap['ridge'].withHeight
        } else {
            return symbolMap['ridge'].withoutHeight
        }
    }
    if(type.includes('mumty')){
        if(height){
            return symbolMap['mumty_structure'].withHeight
        } else {
            return symbolMap['mumty_structure'].withoutHeight
        }
    }
    if(type.includes('lifeline')){
        if(height){
            return symbolMap['lifeline'].withHeight
        } else {
            return symbolMap['lifeline'].withoutHeight
        }
    }
    if(type.includes('handrail')){
        if(height){
            return symbolMap['handrail'].withHeight
        } else {
            return symbolMap['handrail'].withoutHeight
        }
    }
    if(type.includes('module_cleaning') || type.includes('cleaning')){
        // globalLayers.lastactiveTool === 'Module_Cleaning_Pipe'
        if(height){
            return symbolMap['modulecleaningpipe'].withHeight
        } else {
            return symbolMap['modulecleaningpipe'].withoutHeight
        }
    }
    if(type.includes('water') || type.includes('tank')){
        if(height){
            return symbolMap['waterstoragetank'].withHeight
        } else {
            return symbolMap['waterstoragetank'].withoutHeight
        }
    }
    if(type.includes('light')){
        if(height){
            return symbolMap['lightningarrestor'].withHeight
        } else {
            return symbolMap['lightningarrestor'].withoutHeight
        }
    }
    if(type.includes('pipeline')){
        if(height){
            return symbolMap['pipelines'].withHeight
        } else {
            return symbolMap['pipelines'].withoutHeight
        }
    }
    if(type.includes('hvac')){
        if(height){
            return symbolMap['hvac_equipment'].withHeight
        } else {
            return symbolMap['hvac_equipment'].withoutHeight
        }
    }
    if(type.includes('existing')){
        if(height){
            return symbolMap['existingsolarmodules'].withHeight
        } else {
            return symbolMap['existingsolarmodules'].withoutHeight
        }
    }
    if(type.includes('parapetwall')){
        if(height){
            return symbolMap['parapetwall'].withHeight
        } else {
            return symbolMap['parapetwall'].withoutHeight
        }
    }
    if(type.includes('tree')){
        if(height){
            return treeSymbolObj().withHeight
        } else {
            return treeSymbolObj().withoutHeight
        }
    }

    if(type.includes('other')){
        if(height){
            return symbolMap['existingsolarmodules'].withHeight
        } else {
            return symbolMap['existingsolarmodules'].withoutHeight
        }
    }

    if(height){
        return symbolMap['building'].withHeight
    } else return symbolMap['building'].withoutHeight

}


export const attach2DsymbolstoGrpahic = (name: roofObsType, height: number) : PolygonSymbol3D => {
    if (name.includes('Existing_Solar_Modules')) {
        return  getSymbols(name, height).withoutHeight
        // return  solarPaneExistingSymbologywithoutHeight(height);
    } else if (name.includes('Water_Tanks')) {
        return  getSymbols(roofObsType.WaterTanks, height).withoutHeight
        // return  InfraSymbologyHeight(height);
    } else if (name.includes('Mumty_Structure')) {
        return  getSymbols(roofObsType.MumtyStructure, height).withoutHeight
        // return  mumtyStructureSymbologywithoutHeight(height);
    } else if (name.includes('HVAC_Equipment')) {
        return  getSymbols(roofObsType.HvacEquipment, height).withoutHeight
        // return  hvacSymbologywithoutHeight(height);
    } else if (name.includes('Pipelines')) {
        return  getSymbols(roofObsType.Pipelines, height).withoutHeight
        // return  pipelineSymbologywithoutHeight(height);
    } else if (name.includes('Parapet_Wall')) { 
        return  getSymbols(roofObsType.ParapetWall, height).withoutHeight
        // globalLayers.parapetwallArr[indx] = height;
        // let data = store.getState().EPCDetails.roofAnalysis.roofDetails[indx].structureDetails;
       
        // store.dispatch(setstructureDetailsbyIndex({ index: indx, ...data, parapetwall: height.toString() }))
        // return  papapetSymbologyHeight(height);
    } else if(name.includes('Tree_Line')){
        return  treeSymbolObj( height).withoutHeight as any
    }  else if(name.includes('Chimn')){
        return  getSymbols(roofObsType.Chimneys, height).withoutHeight
    }
    else if(name.includes('Helip')){
        return  getSymbols(roofObsType.Helipad, height).withoutHeight
    }
    else if(name.includes('Skyl')){
        return  getSymbols(roofObsType.Skylights, height).withoutHeight
    }
    else if(name.includes('Mobile')){
        return  getSymbols(roofObsType.Mobile ,height).withoutHeight
    }
    else if(name.toLowerCase().includes('build')){
        return  getSymbols(roofObsType.Building ,height).withoutHeight
    }
    else {
        return  getSymbols(roofObsType.Handrail, height).withoutHeight
    }

}
export const attach3DsymbolstoGrpahic = (name: string, height: number) : PolygonSymbol3D => {
    if (name.includes('Existing_Solar_Modules')) {
        return  getSymbols(roofObsType.ExistingSolarModules, height).withHeight
        // return  solarPaneExistingSymbologywithHeight(height);
    } else if (name.includes('Water_Tanks')) {
        return  getSymbols(roofObsType.WaterTanks, height).withHeight
        // return  InfraSymbologyHeight(height);
    } else if (name.includes('Mumty_Structure')) {
        return  getSymbols(roofObsType.MumtyStructure, height).withHeight
        // return  mumtyStructureSymbologywithHeight(height);
    } else if (name.includes('HVAC_Equipment')) {
        return  getSymbols(roofObsType.HvacEquipment, height).withHeight
        // return  hvacSymbologywithHeight(height);
    } else if (name.includes('Pipelines')) {
        return  getSymbols(roofObsType.Pipelines, height).withHeight
        // return  pipelineSymbologywithHeight(height);
    } else if (name.includes('Parapet_Wall')) { 
        return  getSymbols(roofObsType.ParapetWall, height).withHeight
        // globalLayers.parapetwallArr[indx] = height;
        // let data = store.getState().EPCDetails.roofAnalysis.roofDetails[indx].structureDetails;
       
        // store.dispatch(setstructureDetailsbyIndex({ index: indx, ...data, parapetwall: height.toString() }))
        // return  papapetSymbologyHeight(height);
    } else if(name.includes('Tree_Line')){
        return  treeSymbolObj( height).withHeight as any
    }  else if(name.includes('Chimn')){
        return  getSymbols(roofObsType.Chimneys, height).withHeight
    }
    else if(name.includes('Helip')){
        return  getSymbols(roofObsType.Helipad, height).withHeight
    }
    else if(name.includes('Skyl')){
        return  getSymbols(roofObsType.Skylights, height).withHeight
    }
    else if(name.includes('Mobile')){
        return  getSymbols(roofObsType.Mobile ,height).withHeight
    }
    else if(name.toLowerCase().includes('build')){
        return  getSymbols(roofObsType.Building ,height).withHeight
    }
    else {
        return  getSymbols(roofObsType.Handrail, height).withHeight
    }

}

export function getPolygonSymbol(){
    return new SimpleFillSymbol(
        getsimpleFillSymbol([173, 150, 50, 0.5], [150, 55, 0])
    )
}